/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { workflows_AssignRequest } from '../models/workflows_AssignRequest';
import type { workflows_PendingCountResponse } from '../models/workflows_PendingCountResponse';
import type { workflows_RemindRequest } from '../models/workflows_RemindRequest';
import type { workflows_TransitionRequest } from '../models/workflows_TransitionRequest';
import type { workflows_WorkflowItemDetailResponse } from '../models/workflows_WorkflowItemDetailResponse';
import type { workflows_WorkflowItemListResponse } from '../models/workflows_WorkflowItemListResponse';
import type { workflows_WorkflowItemResponse } from '../models/workflows_WorkflowItemResponse';
import type { workflows_WorkflowItemStatsResponse } from '../models/workflows_WorkflowItemStatsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkflowItemsService {
    /**
     * List workflow items
     * List workflow items with pagination and optional filters (category, state, assigned_role, assigned_to). A caller without the workflows module (the employee app) always gets mine: the items assigned to them, plus with lead=true the unheld items of the children whose main group they lead. Admin-only categories are excluded for non-admin callers; employee_data change requests are excluded for callers who are neither admin nor employees holders, time_correction change requests for callers who are neither admin nor time-tracking-workforce holders.
     * @param limit Limit
     * @param offset Offset
     * @param category Filter by workflow category
     * @param state Filter by current state
     * @param assignedRole Filter by assigned role
     * @param assignedTo Filter by assigned user ID
     * @param pending Only items needing operator attention (matches the pending badge across all categories)
     * @param mine Only items assigned to the caller; for an admin also the unassigned admin-role items (the stats' my_tasks rule)
     * @param lead With mine, a non-admin caller also gets the unheld items about the children whose main group they lead (the group lead's inbox); ignored for admins
     * @param overdue Only open items whose deadline has passed
     * @param dueToday Only open items due today in the organisation's time zone
     * @param unassigned Only items no person holds
     * @param completed Only completed items (the done view)
     * @param q Search text (trimmed, first 100 characters): case-insensitive substring of the child name, the summary, the requesting and counterpart employee name in the payload, a dunning item's debtor or one of its children, the employee holding the item, or for an unheld item that is not admin-only the group lead of its child's main group
     * @param sort Sort order: due_asc (soonest deadline first, undated last), due_desc, created_asc; default newest first
     * @returns workflows_WorkflowItemListResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkflowItems(
        limit: number = 10,
        offset?: number,
        category?: string,
        state?: string,
        assignedRole?: string,
        assignedTo?: string,
        pending?: boolean,
        mine?: boolean,
        lead?: boolean,
        overdue?: boolean,
        dueToday?: boolean,
        unassigned?: boolean,
        completed?: boolean,
        q?: string,
        sort?: 'due_asc' | 'due_desc' | 'created_asc',
    ): CancelablePromise<workflows_WorkflowItemListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workflow-items',
            query: {
                'limit': limit,
                'offset': offset,
                'category': category,
                'state': state,
                'assigned_role': assignedRole,
                'assigned_to': assignedTo,
                'pending': pending,
                'mine': mine,
                'lead': lead,
                'overdue': overdue,
                'due_today': dueToday,
                'unassigned': unassigned,
                'completed': completed,
                'q': q,
                'sort': sort,
            },
            errors: {
                401: `Authentication required`,
                403: `Missing organization context`,
                500: `Failed to list workflow items`,
            },
        });
    }
    /**
     * Get a workflow item
     * Get a workflow item by ID with its full transition history. An employee_data change request is visible only to admins and employees holders, a time_correction request only to admins and time-tracking-workforce holders; anyone else gets the same 404 as for a missing item. A caller without the workflows module (the employee app) gets the same 404 for an item they neither hold nor lead the child's main group of.
     * @param id Workflow Item ID
     * @returns workflows_WorkflowItemDetailResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkflowItems1(
        id: string,
    ): CancelablePromise<workflows_WorkflowItemDetailResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workflow-items/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid ID format`,
                401: `Authentication required`,
                403: `Missing organization context or admin access required`,
                404: `Workflow item not found`,
                500: `Failed to get workflow item`,
            },
        });
    }
    /**
     * Hand a workflow item to a person
     * Sets or clears the person responsible for an item (assigned_to). The role the item was raised for stays. The change is recorded in the item's timeline as an `assign` or `unassign` row. The assignee must be an active employee of the organisation with a login. Admin-only categories can be assigned by admins only, and only to admins (422 WORKFLOW_ASSIGNEE_CANNOT_SEE). An admin or the group lead of the item's child may hand the item to anyone; anyone else may only take it, hand it to the group lead, or take themselves off it (403 WORKFLOW_ASSIGN_FORBIDDEN). A hand-over to someone other than the caller sends the workflow_assigned push. A caller without the workflows module (the employee app) gets 404 for an item they neither hold nor lead the child's main group of.
     * @param id Workflow item ID
     * @param request Assignment
     * @returns workflows_WorkflowItemResponse OK
     * @throws ApiError
     */
    public static postApiV1WorkflowItemsAssign(
        id: string,
        request: workflows_AssignRequest,
    ): CancelablePromise<workflows_WorkflowItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workflow-items/{id}/assign',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Admin access required, or WORKFLOW_ASSIGN_FORBIDDEN`,
                404: `Workflow item not found`,
                409: `The item changed meanwhile`,
                422: `Completed item, the assignee cannot take items, or WORKFLOW_ASSIGNEE_CANNOT_SEE`,
                500: `Failed to assign workflow item`,
            },
        });
    }
    /**
     * Remind the person responsible for a workflow item
     * Sends the workflow_reminder push to the person who holds the item, or to the group lead of the item's child when nobody does (never on an admin-only item), and records a `remind` row in the item's timeline (metadata reminded_user_id, reminded_name, comment). Only an admin or the group lead may remind (403 WORKFLOW_REMIND_FORBIDDEN). Nobody to remind, or the only recipient is the caller: 422 WORKFLOW_NO_HOLDER. At most one reminder per item and person per hour: 422 WORKFLOW_REMINDER_TOO_SOON. A caller without the workflows module (the employee app) gets 404 for an item they neither hold nor lead the child's main group of.
     * @param id Workflow item ID
     * @param request Reminder
     * @returns workflows_WorkflowItemResponse OK
     * @throws ApiError
     */
    public static postApiV1WorkflowItemsRemind(
        id: string,
        request: workflows_RemindRequest,
    ): CancelablePromise<workflows_WorkflowItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workflow-items/{id}/remind',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Admin access required, or WORKFLOW_REMIND_FORBIDDEN`,
                404: `Workflow item not found`,
                422: `Completed item, WORKFLOW_NO_HOLDER or WORKFLOW_REMINDER_TOO_SOON`,
                500: `Failed to send the reminder`,
            },
        });
    }
    /**
     * Transition a workflow item
     * Fire an FSM action on a workflow item with an optional comment. A reject on a change request may carry parent_note, the reason the requesting parent or employee sees; parent_note with any other action is a 400. Rejecting an employee_data or time_correction change request requires parent_note (400 CHANGE_REQUEST_REASON_REQUIRED). An employee_data item is visible only to admins and employees holders, a time_correction item only to admins and time-tracking-workforce holders; anyone else gets the 404 of a missing item for every action. A caller without the workflows module (the employee app) gets the same 404 for an item they neither hold nor lead the child's main group of.
     * @param id Workflow Item ID
     * @param transition Transition data
     * @returns workflows_WorkflowItemResponse OK
     * @throws ApiError
     */
    public static postApiV1WorkflowItemsTransition(
        id: string,
        transition: workflows_TransitionRequest,
    ): CancelablePromise<workflows_WorkflowItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workflow-items/{id}/transition',
            path: {
                'id': id,
            },
            body: transition,
            errors: {
                400: `Invalid ID format or request body, CHANGE_REQUEST_REASON_REQUIRED, or WORKFLOW_COMMENT_REQUIRED`,
                401: `Authentication required or missing user context`,
                403: `Missing organization context or admin access required`,
                404: `Workflow item not found`,
                409: `Workflow item was modified by another user`,
                422: `Invalid action or item already completed`,
                500: `Failed to transition workflow item`,
            },
        });
    }
    /**
     * Count pending workflow items
     * Returns the count of non-completed workflow items for the organization. A caller without the workflows module (the employee app) counts only their own items, plus with lead=true the unheld items of the children whose main group they lead.
     * @param lead For a caller without the workflows module: also count the unheld items of the children whose main group they lead
     * @returns workflows_PendingCountResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkflowItemsPendingCount(
        lead?: boolean,
    ): CancelablePromise<workflows_PendingCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workflow-items/pending/count',
            query: {
                'lead': lead,
            },
            errors: {
                401: `Authentication required`,
                403: `Missing organization context`,
                500: `Failed to count pending items`,
            },
        });
    }
    /**
     * Workflow inbox counts
     * Counts the caller's pending workflow items (not closed, no completed_at) in one statement: pending, overdue (due before now), due_today (due on today's date in the organisation's time zone) and my_tasks (assigned to the caller, or, for an admin, unassigned with the admin role; with lead=true a non-admin also counts the unheld items of the children whose main group they lead). The same items the list returns to this caller: admin-only categories are excluded for non-admins, and the change request families the caller may not see are excluded. A caller without the workflows module (the employee app) counts only their own set in every figure. leads_group says whether the caller leads a group (lead=true only).
     * @param lead Non-admin callers: add the unheld items of the children whose main group the caller leads to my_tasks, and fill leads_group
     * @returns workflows_WorkflowItemStatsResponse OK
     * @throws ApiError
     */
    public static getApiV1WorkflowItemsStats(
        lead?: boolean,
    ): CancelablePromise<workflows_WorkflowItemStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workflow-items/stats',
            query: {
                'lead': lead,
            },
            errors: {
                401: `Authentication required`,
                403: `Missing organization context`,
                500: `Failed to count workflow items`,
            },
        });
    }
}
